import React from "react";
import Marquee from "react-fast-marquee";

const OurClients = () => {
  const images = [
    "/assets/Images/Clients/ARKS Builders and Contractor.png",
    "/assets/Images/Clients/Durva Builders.png",
    "/assets/Images/Clients/L&T.png",
    "/assets/Images/Clients/Mahindra life.png",
    "/assets/Images/Clients/Mehta Developers.png",
    "/assets/Images/Clients/Sadguru Interiors.png",
    "/assets/Images/Clients/Shee Interior.png",
    "/assets/Images/Clients/Span Interiors.png",
  ];

  return (
    <div className="p-4">
      <p className=" text-blue-950 md:text-[24px] text-center text-[20px] font-bold">
        Our Clients
      </p>

      <div className="relative overflow-hidden ">
        {/* Marquee Component */}
        <Marquee speed={70} gradient={false} className="flex items-center">
          {images.map((src, index) => (
            <img
              key={`brand-${index}`}
              src={src}
              alt={`Brand ${index + 1}`}
              className="object-contain w-16 h-20 md:mx-8 mx-4 md:w-28 md:h-28 lg:w-40 lg:h-40"
            />
          ))}
        </Marquee>
      </div>
    </div>
  );
};

export default OurClients;
